(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-marquee__track');
      if (!this.track || !this.track.children.length) return;

      const copies = parseInt(this.track.dataset.copies || '2', 10);
      const perCopy = Math.floor(this.track.children.length / copies);
      if (perCopy < 1) return;

      this.originals = Array.from(this.track.children)
        .slice(0, perCopy)
        .map((el) => el.cloneNode(true));

      this.layout();

      this._onResize = () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.layout(), 200);
      };
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      clearTimeout(this._resizeTimer);
    }

    _appendCopy(hidden) {
      this.originals.forEach((child) => {
        const clone = child.cloneNode(true);
        if (hidden) {
          clone.setAttribute('aria-hidden', 'true');
          const link = clone.querySelector('a');
          if (link) link.setAttribute('tabindex', '-1');
        }
        this.track.appendChild(clone);
      });
    }

    layout() {
      this.track.innerHTML = '';
      this._appendCopy(false);
      this._appendCopy(true);

      const minWidth = Math.max(window.innerWidth * 2, 1);
      let safety = 10;
      while (this.track.scrollWidth < minWidth && safety > 0) {
        this._appendCopy(true);
        this._appendCopy(true);
        safety -= 1;
      }

      const speedSetting = parseFloat(this.dataset.speed || '5');
      const pxPerSec = 400 / Math.max(speedSetting, 1);
      const halfWidth = this.track.scrollWidth / 2;
      const duration = Math.max(halfWidth / pxPerSec, 8);
      this.track.style.animationDuration = duration + 's';
    }
  }

  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class CollectionListCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cl__track');
      if (!this.track) return;
      if (this.dataset.carousel !== 'true') return;

      this.origSlides = Array.from(this.track.querySelectorAll('.cl__slide'));
      if (this.origSlides.length < 2) return;

      this._bp = 750;
      this._mobile = false;
      this._jumping = false;
      this._ready = false;
      this._onScroll = this._onScroll.bind(this);
      this._onScrollEnd = this._onScrollEnd.bind(this);
      this._hasScrollEnd = 'onscrollend' in window;

      this._check();

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(
          function () {
            this._check();
          }.bind(this)
        );
        this._ro.observe(this);
      }
    }

    _check() {
      var mobile = window.innerWidth < this._bp;
      if (mobile === this._mobile && this._ready) return;
      this._mobile = mobile;
      this._ready = true;
      if (mobile) {
        this._initMobile();
      } else {
        this._destroyMobile();
      }
    }

    _initMobile() {
      this._destroyMobile();
      var self = this;
      var count = this.origSlides.length;
      var sets = count <= 3 ? 3 : count <= 6 ? 2 : 1;

      function makeClone(slide) {
        var c = slide.cloneNode(true);
        c.classList.add('cl__slide--clone');
        c.classList.remove('cl__slide--featured');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return c;
      }

      for (var s = 0; s < sets; s++) {
        this.origSlides.forEach(function (slide) {
          self.track.appendChild(makeClone(slide));
        });
      }
      for (var s = 0; s < sets; s++) {
        for (var i = count - 1; i >= 0; i--) {
          this.track.prepend(makeClone(this.origSlides[i]));
        }
      }

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      if (this._hasScrollEnd) {
        this.track.addEventListener('scrollend', this._onScrollEnd);
      }

      requestAnimationFrame(function () {
        self._recalc();
        self._jumpToInitial();
      });
    }

    _destroyMobile() {
      this.track.querySelectorAll('.cl__slide--clone').forEach(function (c) {
        c.remove();
      });
      this.track.removeEventListener('scroll', this._onScroll);
      if (this._hasScrollEnd) {
        this.track.removeEventListener('scrollend', this._onScrollEnd);
      }
      clearTimeout(this._scrollTimer);
    }

    _recalc() {
      if (!this.origSlides.length) return;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this._gap = gap;
      this._slideWidth = this.origSlides[0].offsetWidth;
      this._loopSize = this.origSlides.reduce(function (sum, s) {
        return sum + s.offsetWidth + gap;
      }, 0);
      this._realStart = this.origSlides[0].offsetLeft;
      this._realEnd = this._realStart + this._loopSize;
    }

    _jumpToInitial() {
      var x =
        this.origSlides[0].offsetLeft -
        (this.track.clientWidth - this.origSlides[0].offsetWidth) / 2;
      this._jumpTo(x);
    }

    _jumpTo(x) {
      if (this._jumping) return;
      this._jumping = true;
      clearTimeout(this._scrollTimer);
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({ left: x, behavior: 'instant' });
      var self = this;
      requestAnimationFrame(function () {
        self.track.style.scrollSnapType = '';
        self._jumping = false;
      });
    }

    _onScroll() {
      if (this._jumping) return;
      if (!this._hasScrollEnd) {
        clearTimeout(this._scrollTimer);
        var self = this;
        this._scrollTimer = setTimeout(function () {
          self._onScrollEnd();
        }, 150);
      }
    }

    _onScrollEnd() {
      if (this._jumping) return;
      this._maybeLoop();
    }

    _maybeLoop() {
      if (this._jumping) return;
      var x = this.track.scrollLeft;
      var center = x + this.track.clientWidth / 2;
      if (center < this._realStart) {
        this._jumpTo(x + this._loopSize);
      } else if (center >= this._realEnd) {
        this._jumpTo(x - this._loopSize);
      }
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      this._destroyMobile();
    }
  }

  if (!customElements.get('collection-list-carousel')) {
    customElements.define('collection-list-carousel', CollectionListCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      var items = document.querySelectorAll('.footer-block__accordion');
      for (var i = 0; i < items.length; i++) {
        if (mq.matches) {
          items[i].removeAttribute('open');
        } else {
          items[i].setAttribute('open', '');
        }
      }
    }
    function blockDesktopToggle(e) {
      if (!mq.matches) {
        e.preventDefault();
      }
    }
    function bind() {
      var summaries = document.querySelectorAll('.footer-block__accordion > summary');
      for (var i = 0; i < summaries.length; i++) {
        summaries[i].addEventListener('click', blockDesktopToggle);
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        sync();
        bind();
      });
    } else {
      sync();
      bind();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // On overlay (home/collection) pages the header wrapper is
      // position: fixed, so .section-header collapses to 0px height -
      // writing that would stomp the value initHeaderOverlay owns via
      // setHeights()/ResizeObserver. Let the overlay script own it there.
      if (this.header.querySelector('.header-wrapper--overlay')) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((search) => search.isOpen)) return;

      // Ignore synthetic scroll events fired while the body is
      // scroll-locked (the immersive search and mobile drawer set
      // body.style.position = 'fixed', which clamps pageYOffset to 0 on
      // open and jumps it back on close - without this guard those two
      // events read as a huge up-then-down scroll and flash the header).
      if (document.body.style.position === 'fixed') return;

      // Hysteresis, same idea as initHeaderOverlay's HIDE_AT/SHOW_AT
      // deadband below: hide and reveal share a single positional
      // threshold (headerBounds.bottom) and otherwise flip on any 1px
      // direction reversal, so trackpad jitter and scroll-anchoring
      // corrections flash the header in and out mid-gesture. Require a
      // minimum accumulated travel in the new direction before toggling.
      const REVEAL_TRAVEL = 12;
      const HIDE_TRAVEL = 24;

      if (scrollTop > this.currentScrollTop) {
        this.upTravel = 0;
        this.downTravel = (this.downTravel || 0) + scrollTop - this.currentScrollTop;
      } else if (scrollTop < this.currentScrollTop) {
        this.downTravel = 0;
        this.upTravel = (this.upTravel || 0) + this.currentScrollTop - scrollTop;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide || this.downTravel < HIDE_TRAVEL) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.upTravel < REVEAL_TRAVEL) {
          this.currentScrollTop = scrollTop;
          return;
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // Null-safe (Dawn v16): the Warhaus immersive search has no
      // details-modal element, so the old single-element version threw
      // a TypeError on every sticky-header hide.
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((modal) => modal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function initCartMirror() {
    const primary = document.getElementById('cart-icon-bubble');
    const mirror = document.querySelector('[data-cart-mobile-mirror]');
    if (!primary || !mirror) return;
    const sync = () => {
      mirror.innerHTML = primary.innerHTML;
    };
    sync();
    new MutationObserver(sync).observe(primary, { childList: true, subtree: true });
  })();

  (function initHeaderOverlay() {
    const overlay = document.querySelector('.header-wrapper--overlay');
    if (!overlay) return;

    const announcementBar = document.querySelector('.utility-bar');
    const root = document.documentElement;
    // Hysteresis / deadband: two thresholds instead of one.
    // iOS elastic overscroll crosses a single threshold repeatedly in
    // <500ms during a bounce, which compounds the 350ms hide/show
    // transitions and causes a "stuck" feeling. With a gap between
    // HIDE_AT and SHOW_AT, oscillation inside the deadband triggers
    // zero toggles and transitions can complete cleanly.
    const HIDE_AT = 48;
    const SHOW_AT = 12;
    let scrolledState = false;
    let ticking = false;

    const setHeights = () => {
      root.style.setProperty('--header-height', `${overlay.offsetHeight}px`);
      if (announcementBar) {
        root.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
      }
    };

    const update = () => {
      // Ignore synthetic scroll events fired while the body is
      // scroll-locked (immersive search sets body.style.position =
      // 'fixed', clamping pageYOffset to 0 - without this the glass
      // state flashes off on open and back on on close).
      if (document.body.style.position === 'fixed') {
        ticking = false;
        return;
      }
      const drawerOpen = document.querySelector('.header-mega-drawer details.menu-drawer-container[open]');
      const y = window.pageYOffset || root.scrollTop;

      if (!scrolledState && y > HIDE_AT) {
        scrolledState = true;
      } else if (scrolledState && y < SHOW_AT) {
        scrolledState = false;
      }

      overlay.classList.toggle('header-wrapper--scrolled', scrolledState);
      if (announcementBar && !drawerOpen) {
        announcementBar.classList.toggle('utility-bar--hidden', scrolledState);
      }
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    setHeights();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeights, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(setHeights);
      ro.observe(overlay);
      if (announcementBar) ro.observe(announcementBar);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const NEWSLETTER_POPUP_SESSION_KEY = 'newsletter-popup-minimized';

  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.delay = Number.parseInt(this.dataset.delay, 10) || 0;
      this.klaviyoCompanyId = (this.dataset.klaviyoCompanyId || '').trim();
      this.klaviyoListId = (this.dataset.klaviyoListId || '').trim();
      this.keyHandler = (event) => {
        if (event.key === 'Escape') this.minimize();
      };
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-popup-close]')) {
          this.minimize();
        } else if (event.target.closest('[data-popup-toggle]')) {
          this.open();
        }
      });

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => this.subscribeToKlaviyo(event));
      }

      // If the visitor has already minimized the popup earlier in this
      // browsing session, start straight in the minimized tab state on
      // subsequent homepage visits. A fresh session (new tab / new day)
      // resets back to the full popup.
      if (this.wasMinimizedThisSession()) {
        this.openMinimizedSilently();
        return;
      }

      window.setTimeout(() => this.open(), this.delay * 1000);
    }

    wasMinimizedThisSession() {
      try {
        return sessionStorage.getItem(NEWSLETTER_POPUP_SESSION_KEY) === '1';
      } catch (_) {
        return false;
      }
    }

    rememberMinimized() {
      try {
        sessionStorage.setItem(NEWSLETTER_POPUP_SESSION_KEY, '1');
      } catch (_) {
        // storage unavailable — session state won't persist
      }
    }

    open() {
      this.hidden = false;
      this.classList.remove('newsletter-popup--minimized');
      document.addEventListener('keydown', this.keyHandler);
      // Only auto-focus on fine-pointer devices (desktop). On touch
      // devices, focusing the email input pops up the on-screen
      // keyboard, which is intrusive — let the visitor tap the field
      // themselves when they're ready to type.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const firstInput = this.querySelector('input[type="email"]');
        if (firstInput) firstInput.focus();
      }
    }

    minimize() {
      // Swap to the compact edge-docked tab. Dialog hides, toggle
      // appears — click the toggle to expand again. Remembered in
      // sessionStorage so navigating back to the homepage keeps it
      // minimized for the rest of the session.
      this.hidden = false;
      this.classList.add('newsletter-popup--minimized');
      document.removeEventListener('keydown', this.keyHandler);
      this.rememberMinimized();
    }

    async subscribeToKlaviyo(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const errorEl = form.querySelector('[data-popup-error]');
      const successEl = form.querySelector('[data-popup-success]');
      const email = emailInput && emailInput.value.trim();

      this.hideMessage(errorEl);
      this.hideMessage(successEl);

      if (!email) {
        this.showError(errorEl, 'Please enter a valid email address.');
        return;
      }
      if (!this.klaviyoCompanyId || !this.klaviyoListId) {
        this.showError(errorEl, 'Newsletter signup is not configured.');
        return;
      }

      if (submitButton) submitButton.disabled = true;

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoCompanyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-10-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Newsletter Popup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: { type: 'list', id: this.klaviyoListId },
                  },
                },
              },
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Klaviyo responded ${response.status}`);
        }

        if (emailInput) emailInput.value = '';
        if (successEl) successEl.hidden = false;
      } catch (_) {
        this.showError(errorEl, 'Something went wrong. Please try again.');
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }

    showError(el, text) {
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
    }

    hideMessage(el) {
      if (!el) return;
      el.hidden = true;
    }

    openMinimizedSilently() {
      // Render directly in the minimized state. CSS transitions don't
      // fire on initial paint (no starting state to transition from),
      // so the dialog is in its collapsed position on first render
      // with no flash. Subsequent expand/minimize toggles within the
      // session still animate via the transition rules.
      this.classList.add('newsletter-popup--minimized');
      this.hidden = false;
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warhaus-about-banner"] && !Shopify.designMode) return;
  try {
    
  class WabBadgesCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wab__badges');
      if (!this.track) return;
      this.origSlides = Array.from(this.track.querySelectorAll('.wab__badge'));
      if (this.origSlides.length < 2) return;

      this._bp = 750;
      this._mobile = false;
      this._jumping = false;
      this._ready = false;
      this._onScroll = this._onScroll.bind(this);
      this._onScrollEnd = this._onScrollEnd.bind(this);
      this._hasScrollEnd = 'onscrollend' in window;

      this._check();

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(
          function () {
            this._check();
          }.bind(this)
        );
        this._ro.observe(this);
      }
    }

    _check() {
      var mobile = window.innerWidth < this._bp;
      if (mobile === this._mobile && this._ready) return;
      this._mobile = mobile;
      this._ready = true;
      if (mobile) {
        this._initMobile();
      } else {
        this._destroyMobile();
      }
    }

    _initMobile() {
      this._destroyMobile();
      var self = this;
      var count = this.origSlides.length;
      var sets = count <= 3 ? 3 : count <= 6 ? 2 : 1;

      function makeClone(slide) {
        var c = slide.cloneNode(true);
        c.classList.add('wab__badge--clone');
        c.setAttribute('aria-hidden', 'true');
        return c;
      }

      for (var s = 0; s < sets; s++) {
        this.origSlides.forEach(function (slide) {
          self.track.appendChild(makeClone(slide));
        });
      }
      for (var s = 0; s < sets; s++) {
        for (var i = count - 1; i >= 0; i--) {
          this.track.prepend(makeClone(this.origSlides[i]));
        }
      }

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      if (this._hasScrollEnd) {
        this.track.addEventListener('scrollend', this._onScrollEnd);
      }

      requestAnimationFrame(function () {
        self._recalc();
        self._jumpToInitial();
      });
    }

    _destroyMobile() {
      if (!this.track) return;
      this.track.querySelectorAll('.wab__badge--clone').forEach(function (c) {
        c.remove();
      });
      this.track.removeEventListener('scroll', this._onScroll);
      if (this._hasScrollEnd) {
        this.track.removeEventListener('scrollend', this._onScrollEnd);
      }
      clearTimeout(this._scrollTimer);
    }

    _recalc() {
      if (!this.origSlides.length) return;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this._gap = gap;
      this._loopSize = this.origSlides.reduce(function (sum, s) {
        return sum + s.offsetWidth + gap;
      }, 0);
      this._realStart = this.origSlides[0].offsetLeft;
      this._realEnd = this._realStart + this._loopSize;
    }

    _jumpToInitial() {
      var x = this.origSlides[0].offsetLeft - (this.track.clientWidth - this.origSlides[0].offsetWidth) / 2;
      this._jumpTo(x);
    }

    _jumpTo(x) {
      if (this._jumping) return;
      this._jumping = true;
      clearTimeout(this._scrollTimer);
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({ left: x, behavior: 'instant' });
      var self = this;
      requestAnimationFrame(function () {
        self.track.style.scrollSnapType = '';
        self._jumping = false;
      });
    }

    _onScroll() {
      if (this._jumping) return;
      if (!this._hasScrollEnd) {
        clearTimeout(this._scrollTimer);
        var self = this;
        this._scrollTimer = setTimeout(function () {
          self._onScrollEnd();
        }, 150);
      }
    }

    _onScrollEnd() {
      if (this._jumping) return;
      this._maybeLoop();
    }

    _maybeLoop() {
      if (this._jumping) return;
      var x = this.track.scrollLeft;
      var center = x + this.track.clientWidth / 2;
      if (center < this._realStart) {
        this._jumpTo(x + this._loopSize);
      } else if (center >= this._realEnd) {
        this._jumpTo(x - this._loopSize);
      }
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      this._destroyMobile();
    }
  }

  if (!customElements.get('wab-badges-carousel')) {
    customElements.define('wab-badges-carousel', WabBadgesCarousel);
  }

  class WabScrollPinned extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.wab__scroller');
      if (!this.scroller) return;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.style.setProperty('--wab-p', '1');
        return;
      }

      this._onScroll = this._onScroll.bind(this);
      this._update = this._update.bind(this);
      this._rafPending = false;

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
    }

    _onScroll() {
      if (this._rafPending) return;
      this._rafPending = true;
      requestAnimationFrame(this._update);
    }

    _update() {
      this._rafPending = false;
      if (!this.scroller) return;
      var rect = this.scroller.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = rect.height - vh;

      /* Entry progress: 0 when the scroller's top first touches the
         viewport bottom, 1 when it reaches viewport top (pin start).
         Drives the mobile "circle rises into view" offset so the
         banner feels active as the user scrolls toward it instead of
         waiting silently in the centre of the sticky. */
      var entry = 1 - rect.top / vh;
      if (entry < 0) entry = 0;
      if (entry > 1) entry = 1;
      this.style.setProperty('--wab-entry', entry.toFixed(4));

      if (scrollable <= 0) {
        this.style.setProperty('--wab-p', '1');
        return;
      }
      var scrolled = -rect.top;
      var p = scrolled / scrollable;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      this.style.setProperty('--wab-p', p.toFixed(4));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  }

  if (!customElements.get('wab-scroll-pinned')) {
    customElements.define('wab-scroll-pinned', WabScrollPinned);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warhaus-arts-crafts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scatters = document.querySelectorAll('[data-wac-scatter]');
    if (!scatters.length) return;

    if (!('IntersectionObserver' in window)) {
      scatters.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    scatters.forEach(function (el) {
      el.classList.add('js-ready');
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warhaus-collection-hero-slider"] && !Shopify.designMode) return;
  try {
    
  const RING_LENGTH = 106.81;
  const TAP_THRESHOLD = 10;
  const SCROLL_END_FALLBACK_MS = 150;

  class WarhausCollectionHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fcc__track');
      this.wrapper = this.querySelector('.fcc__wrapper');
      this.cursor = this.querySelector('.fcc__cursor');
      this.slides = [...this.querySelectorAll('.fcc__slide')];
      this.counters = [...this.querySelectorAll('.fcc__counter')];
      this.backdrops = [...this.querySelectorAll('.fcc__backdrop-img')];

      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.paused = false;
      this.current = 0;
      // One-shot guard: set true right before WE scroll programmatically, so the
      // scrollend it produces is ignored (we're already in sync). A user touch
      // clears it, so a swipe that interrupts a programmatic scroll still re-syncs.
      this._programmatic = false;
      this.userTouching = false;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const cursorMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

      // Scroll resync: prefer scrollend, debounced fallback otherwise.
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this._onScrollEnd(), { signal });
      } else {
        this.track.addEventListener(
          'scroll',
          () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this._onScrollEnd(), SCROLL_END_FALLBACK_MS);
          },
          { passive: true, signal }
        );
      }

      this.counters.forEach((btn, i) => {
        btn.addEventListener(
          'click',
          () => {
            this.go(i);
            this._restartAutoplay();
          },
          { signal }
        );
      });

      const pauseBtn = this.querySelector('.fcc__pause');
      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => this._togglePause(pauseBtn), { signal });
      }

      // Touch: pause autoplay AND freeze the active countdown ring
      // during the gesture so nothing ticks under the user's finger.
      // Restart logic on touchend depends on whether the user actually
      // scrolled — if they did, scrollend handles re-activation; if
      // they just tapped, we restart here. Avoids a double-activate
      // race that flashed two rings counting at once.
      let touchStart = null;
      let touchStartScrollLeft = 0;
      this.track.addEventListener(
        'touchstart',
        (e) => {
          this.userTouching = true;
          // The user now owns the scroll: drop any pending autoplay tick and
          // cancel the programmatic guard so THIS gesture's scrollend re-syncs,
          // even when it interrupts an in-flight autoplay slide change.
          clearTimeout(this.timer);
          this._programmatic = false;
          this._freezeRing();
          touchStartScrollLeft = this.track.scrollLeft;
          const t = e.changedTouches?.[0];
          touchStart = t && !this._isInteractive(e.target) ? { x: t.clientX, y: t.clientY } : null;
        },
        { passive: true, signal }
      );

      this.track.addEventListener(
        'touchend',
        (e) => {
          this.userTouching = false;
          const t = e.changedTouches?.[0];
          if (touchStart && t) {
            const dx = Math.abs(t.clientX - touchStart.x);
            const dy = Math.abs(t.clientY - touchStart.y);
            if (dx < TAP_THRESHOLD && dy < TAP_THRESHOLD) this._navigateToActive();
          }
          touchStart = null;
          // Only restart manually if no scroll happened — otherwise
          // scrollend will fire shortly and re-activate cleanly.
          if (this.track.scrollLeft === touchStartScrollLeft) {
            this._restartCountdown();
          }
        },
        { passive: true, signal }
      );

      // Desktop hover cursor + click-zone navigation.
      if (this.wrapper && this.slides.length > 1) {
        this.wrapper.addEventListener(
          'mousemove',
          (e) => {
            if (!cursorMq.matches || !this.cursor) return;
            if (this._isInteractive(e.target)) return this._hideCursor();
            this._showCursor(e);
          },
          { signal }
        );

        this.wrapper.addEventListener('mouseleave', () => this._hideCursor(), { signal });

        this.wrapper.addEventListener(
          'click',
          (e) => {
            if (!cursorMq.matches || this._isInteractive(e.target)) return;
            const zone = this._zoneFor(e.clientX);
            if (zone === 'right') this.next();
            else if (zone === 'left') this.prev();
            else return this._navigateToActive();
            this._restartAutoplay();
          },
          { signal }
        );
      }

      this.activate(0);
      if (this.autoplay) this.schedule();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.scrollTimer);
      this.controller?.abort();
    }

    next() {
      this.go((this.current + 1) % this.slides.length);
    }
    prev() {
      this.go((this.current - 1 + this.slides.length) % this.slides.length);
    }

    go(idx) {
      this.current = idx;
      this._programmatic = true;
      this.activate(idx);
      const slide = this.slides[idx];
      if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    activate(idx) {
      this.slides.forEach((slide, i) => slide.classList.toggle('fcc__slide--active', i === idx));
      this.backdrops.forEach((bg, i) => bg.classList.toggle('fcc__backdrop-img--active', i === idx));

      this.counters.forEach((btn, i) => {
        const fill = btn.querySelector('.fcc__ring-fill');
        const active = i === idx;
        btn.classList.toggle('fcc__counter--active', active);
        btn.setAttribute('aria-selected', active);
        if (!fill) return;
        fill.style.transition = 'none';
        if (!active) {
          fill.style.strokeDashoffset = RING_LENGTH;
          return;
        }
        if (this.autoplay && !this.paused) {
          fill.style.strokeDashoffset = RING_LENGTH;
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              fill.style.transition = `stroke-dashoffset ${this.speed}ms linear`;
              fill.style.strokeDashoffset = 0;
            })
          );
        } else {
          fill.style.strokeDashoffset = 0;
        }
      });
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.userTouching) return;
        this.next();
        this.schedule();
      }, this.speed);
    }

    _onScrollEnd() {
      // Our own smooth scroll settling — already in sync, so consume the guard.
      if (this._programmatic) {
        this._programmatic = false;
        return;
      }
      const idx = this._closestSlide();
      if (idx === -1) return;
      // User-driven settle. Always re-activate (resets all rings + restarts the
      // countdown on the active one) so a swipe that lands on the same slide
      // still clears the frozen ring state from touchstart.
      this.current = idx;
      this.activate(idx);
      this._restartAutoplay();
    }

    _closestSlide() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = -1;
      let closestDist = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    _togglePause(btn) {
      this.paused = !this.paused;
      btn.classList.toggle('fcc__pause--paused', this.paused);
      if (this.paused) {
        clearTimeout(this.timer);
        this._freezeRing();
      } else {
        this.activate(this.current);
        this.schedule();
      }
    }

    _restartAutoplay() {
      if (!this.autoplay || this.paused) return;
      clearTimeout(this.timer);
      this.schedule();
    }

    _freezeRing() {
      const fill = this.counters[this.current]?.querySelector('.fcc__ring-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.strokeDashoffset = getComputedStyle(fill).strokeDashoffset;
    }

    _restartCountdown() {
      if (!this.autoplay || this.paused) return;
      this.activate(this.current);
      this.schedule();
    }

    _navigateToActive() {
      const href = this.slides[this.current]?.dataset.href;
      if (href) window.location.assign(href);
    }

    _isInteractive(target) {
      return !!(target.closest('.fcc__content') || target.closest('.fcc__controls') || target.closest('a, button'));
    }

    _zoneFor(clientX) {
      const rect = this.wrapper.getBoundingClientRect();
      const ratio = (clientX - rect.left) / rect.width;
      if (ratio < 0.2) return 'left';
      if (ratio > 0.8) return 'right';
      return 'center';
    }

    _showCursor(e) {
      const zone = this._zoneFor(e.clientX);
      this.cursor.classList.toggle('fcc__cursor--left', zone === 'left');
      this.cursor.classList.toggle('fcc__cursor--right', zone === 'right');
      this.cursor.classList.toggle('fcc__cursor--center', zone === 'center');
      this.cursor.classList.add('fcc__cursor--visible');
      this.wrapper.classList.add('fcc__wrapper--cursor-active');
      this.cursor.style.left = e.clientX + 'px';
      this.cursor.style.top = e.clientY + 'px';
    }

    _hideCursor() {
      this.cursor?.classList.remove('fcc__cursor--visible');
      this.wrapper.classList.remove('fcc__wrapper--cursor-active');
    }
  }

  customElements.define('warhaus-collection-hero-slider', WarhausCollectionHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warhaus-products-carousel"] && !Shopify.designMode) return;
  try {
    
  class WarhausProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wpc__track');
      this.prevBtn = this.querySelector('.wpc__nav--prev');
      this.nextBtn = this.querySelector('.wpc__nav--next');
      if (!this.track) return;

      this.origSlides = Array.from(this.track.querySelectorAll('.wpc__slide'));
      if (this.origSlides.length < 2) return;

      this._jumping = false;
      this._onScroll = this._onScroll.bind(this);
      this._onScrollEnd = this._onScrollEnd.bind(this);

      this._setupClones();

      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      this._hasScrollEnd = 'onscrollend' in window;
      if (this._hasScrollEnd) {
        this.track.addEventListener('scrollend', this._onScrollEnd);
      }

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._scrollBySlide(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._scrollBySlide(1));

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => this._recalc());
        this._ro.observe(this.track);
      }

      requestAnimationFrame(() => {
        this._recalc();
        this._jumpToInitial();
      });
    }

    _setupClones() {
      const count = this.origSlides.length;
      const sets = count <= 3 ? 3 : count <= 6 ? 2 : 1;

      let cloneIdx = 0;
      const makeClone = (slide) => {
        const c = slide.cloneNode(true);
        c.classList.add('wpc__slide--clone');
        // Hide clones from the a11y tree and pull their focusable descendants
        // (links, buttons, form controls) out of the tab order so they don't
        // create duplicate tab stops — this satisfies axe's aria-hidden-focus
        // rule. We deliberately do NOT use `inert`: inert also swallows mouse
        // clicks, which made cloned cards look identical to real ones but
        // unclickable wherever a clone sat under the cursor. tabindex="-1"
        // keeps them out of keyboard nav while leaving the card link clickable
        // (it targets the same product, so clicking a clone navigates fine).
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        cloneIdx++;
        c.querySelectorAll('[id]').forEach((el) => {
          el.id = el.id + '-clone-' + cloneIdx;
        });
        c.querySelectorAll('label[for]').forEach((el) => {
          el.setAttribute('for', el.getAttribute('for') + '-clone-' + cloneIdx);
        });
        return c;
      };

      for (let s = 0; s < sets; s++) {
        this.origSlides.forEach((slide) => this.track.appendChild(makeClone(slide)));
      }
      for (let s = 0; s < sets; s++) {
        for (let i = count - 1; i >= 0; i--) {
          this.track.prepend(makeClone(this.origSlides[i]));
        }
      }
    }

    _recalc() {
      if (!this.origSlides.length) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this._gap = gap;
      this._slideWidth = this.origSlides[0].offsetWidth;
      this._loopSize = this.origSlides.reduce((sum, s) => sum + s.offsetWidth + gap, 0);
      this._realStart = this.origSlides[0].offsetLeft;
      this._realEnd = this._realStart + this._loopSize;
    }

    _jumpToInitial() {
      const snapAlign = getComputedStyle(this.origSlides[0]).scrollSnapAlign;
      let x;
      if (snapAlign.includes('center')) {
        x = this.origSlides[0].offsetLeft - (this.track.clientWidth - this.origSlides[0].offsetWidth) / 2;
      } else {
        x = this.origSlides[0].offsetLeft;
      }
      this._jumpTo(x);
    }

    _jumpTo(x) {
      if (this._jumping) return;
      this._jumping = true;
      clearTimeout(this._scrollTimer);
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({ left: x, behavior: 'instant' });
      requestAnimationFrame(() => {
        this.track.style.scrollSnapType = '';
        this._jumping = false;
      });
    }

    _onScroll() {
      if (this._jumping) return;
      if (!this._hasScrollEnd) {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(() => this._onScrollEnd(), 150);
      }
    }

    _onScrollEnd() {
      if (this._jumping) return;
      this._maybeLoop();
    }

    _maybeLoop() {
      if (this._jumping) return;
      const x = this.track.scrollLeft;
      const center = x + this.track.clientWidth / 2;
      if (center < this._realStart) {
        this._jumpTo(x + this._loopSize);
      } else if (center >= this._realEnd) {
        this._jumpTo(x - this._loopSize);
      }
    }

    _scrollBySlide(direction) {
      if (!this.origSlides.length) return;
      const step = this._slideWidth + this._gap;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      this.track.removeEventListener('scroll', this._onScroll);
      if (this._hasScrollEnd) {
        this.track.removeEventListener('scrollend', this._onScrollEnd);
      }
      clearTimeout(this._scrollTimer);
    }
  }

  if (!customElements.get('warhaus-products-carousel')) {
    customElements.define('warhaus-products-carousel', WarhausProductsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
